import * as React from 'react'

import { disableScroll, enableScroll } from '../../lib/utils'
import { createContextHook } from '../../lib/utils/createContextHook'

interface ISearchOverlay {
  closeSearchOverlay(): void
  shouldDisplaySearchOverlay: boolean
  toggleSearchOverlay(): void
}

/**
 * @deprecated No longer relevant in app directory with new nav header and search.
 */
export const SearchOverlayContext = React.createContext<ISearchOverlay | undefined>(undefined)

/**
 * @deprecated No longer relevant in app directory with new nav header and search.
 */
export const SearchOverlayContextProvider: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  const [shouldDisplaySearchOverlay, setShouldDisplaySearchOverlay] = React.useState<boolean>(false)

  const closeSearchOverlay = React.useCallback(() => {
    setShouldDisplaySearchOverlay(false)
  }, [])

  const toggleSearchOverlay = React.useCallback(() => {
    setShouldDisplaySearchOverlay(current => !current)
  }, [])

  React.useEffect(() => {
    if (shouldDisplaySearchOverlay) {
      disableScroll()
    } else {
      enableScroll()
    }
  }, [shouldDisplaySearchOverlay])

  return (
    <SearchOverlayContext.Provider
      value={{
        closeSearchOverlay,
        shouldDisplaySearchOverlay,
        toggleSearchOverlay,
      }}
    >
      {children}
    </SearchOverlayContext.Provider>
  )
}

/**
 * @deprecated No longer relevant in app directory with new nav header and search.
 */
export const useSearchOverlayContext = createContextHook(
  SearchOverlayContext,
  'SearchOverlayContext'
)
